var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconOrderActiveAsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M1.84489 4L5 0.72111L8.15511 4H1.84489Z",
    stroke: "#0E4C54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84489 7L5 10.2789L8.15511 7H1.84489Z",
    stroke: "#0E4C54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrderActiveAsc);
export default __webpack_public_path__ + "static/media/icon-order-active-asc.27e1a7803a76ffac976c6f807b3604dd.svg";
export { ForwardRef as ReactComponent };